var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AC011CF1-1D57-4071-A197-AC1B548DD365") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional---Bold",
    transform: "translate(-364.000000, -316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share",
    transform: "translate(364.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6391153,12.0815372 C19.3991153,9.8815372 18.2191157,7.9015373 16.3991157,6.64153731 C16.0691157,6.4115373 15.9891154,5.96153757 16.2191154,5.63153756 C16.4491154,5.30153754 16.8991156,5.22153725 17.2291156,5.45153725 C19.3991157,6.96153724 20.7991161,9.32153773 21.0891161,11.9315376 C21.1291161,12.3315376 20.8391165,12.6915369 20.4391165,12.7315369 C20.4091165,12.7315369 20.3891166,12.7315369 20.3591166,12.7315369 C19.9891165,12.7315369 19.6791153,12.4515373 19.6391153,12.0815372 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.669312,12.781178 C3.26931199,12.741178 2.97931189,12.3811778 3.01931188,11.9811778 C3.28931189,9.37117791 4.669312,7.01117781 6.8193121,5.49117783 C7.13931209,5.26117782 7.59931184,5.34117791 7.82931185,5.6611779 C8.05931185,5.99117792 7.97931176,6.4411781 7.65931177,6.6711781 C5.85931182,7.95117807 4.68931171,9.93117809 4.46931171,12.1211782 C4.42931172,12.5011781 4.10931194,12.781178 3.73931193,12.781178 C3.71931193,12.781178 3.689312,12.781178 3.669312,12.781178 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0605893,21.9903331 C10.6205893,21.9903331 9.25058863,21.6703337 7.97058865,21.0203338 C7.61058864,20.8503338 7.47058895,20.4103326 7.65058896,20.0503326 C7.82058896,19.6903326 8.26058877,19.5503327 8.62058878,19.7203327 C9.25058877,20.0403327 9.92058927,20.2603328 10.6005893,20.3903328 C11.5205893,20.5703328 12.460589,20.5803334 13.380589,20.4203334 C14.060589,20.3003334 14.7305893,20.0903343 15.3505893,19.7903343 C15.7205893,19.6203343 16.1605881,19.7603325 16.3205881,20.1303325 C16.5005881,20.4903325 16.3605882,20.9303337 15.9905882,21.1003337 C14.7605882,21.6903337 13.4405893,21.9903331 12.0605893,21.9903331 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23046875,4.83171868 C9.23046875,6.39171863 10.4904695,7.65171909 12.0504694,7.65171909 C13.6104693,7.65171909 14.8704691,6.39171863 14.8704691,4.83171868 C14.8704691,3.27171874 13.6104693,2.01171875 12.0504694,2.01171875 C10.5004694,2.01171875 9.23046875,3.27171874 9.23046875,4.83171868 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.23046875,16.6910944 C2.23046875,18.2510943 3.49046898,19.5110941 5.05046892,19.5110941 C6.61046886,19.5110941 7.87046862,18.2510943 7.87046862,16.6910944 C7.87046862,15.1310945 6.60046887,13.8710938 5.05046892,13.8710938 C3.50046897,13.8710938 2.23046875,15.1310945 2.23046875,16.6910944 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1308594,16.6910944 C16.1308594,18.2510943 17.390861,19.5110941 18.950861,19.5110941 C20.5108609,19.5110941 21.7708607,18.2510943 21.7708607,16.6910944 C21.7708607,15.1310945 20.5108609,13.8710938 18.950861,13.8710938 C17.400861,13.8710938 16.1308594,15.1310945 16.1308594,16.6910944 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(-180.000000) translate(-12.000000, -12.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldShare);
export default __webpack_public_path__ + "static/media/vuesax-bold-share.df2b69b0a6c6ae9eb379ca5425716f56.svg";
export { ForwardRef as ReactComponent };